<template>
  <div class="select-element-item d-flex align-center">
    <v-icon v-if="icon" :color="icon.color" :title="icon.label" size="small" class="mr-2">
      {{ icon.name }}
    </v-icon>
    <v-icon v-else-if="alignIcons" size="small" class="mr-2"></v-icon>
    <planning-element-view :el="item" :show-details-items="[]" class="flex-grow-1 nobr events-disabled"
                           style="position: static; font-size: 75%; max-width: 220px" disable-mini-element disable-styling>
    </planning-element-view>
    <small v-if="startTime" class="ml-2 text-medium-emphasis">
      {{ startTime }}
    </small>
    <small v-if="! item.isType('milestone') && endTime" class="text-medium-emphasis">
      &nbsp;- {{ endTime }}
    </small>
  </div>
</template>

<style lang="scss">
  .select-element-item .element {
    .elementmain, .element-title {
      border-radius: 8px; // against element-overflow-xxx
    }

    .task-icon, .macro-icon, .milestone-icon {
      display: none;
    }
    .element-title {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }

    &.macro .element-title {
      min-height: 20px !important; /* reduced */
    }
  }
</style>

<script>
  import PlanningElementView from '@/components/Planning/PlanningElementView.vue';

  export default {
    components: {
      PlanningElementView,
    },
    props: {
      item: { type: Object, required: true },
      planningLocale: { type: String, required: true },
      alignIcons: { type: Boolean, default: false },
    },
    computed: {
      icon() {
        return this.item.hasIcon() ? this.item.getIcon() : null;
      },
      startTime() {
        const starttime = this.item.getStartTime();
        return starttime ? this.$filters.moment(starttime, 'mediumDateConditionalYear', this.planningLocale) : null;
      },
      endTime() {
        const endtime = this.item.getEndTime();
        return endtime ? this.$filters.moment(endtime, 'mediumDateConditionalYear', this.planningLocale) : null;
      },
    },
  };
</script>
